import { SimpleGrid } from '@chakra-ui/react';
import React from 'react';

import { Util } from '@finley-technologies/finley-types';

import {
  AttributeTypeGQLType,
  AttributeValueInputGQLType,
} from '../../../../../types/dashboard-core-gqlTypes.generated';
import { mapAttributeToGQLValue } from '../../../common-frontend/components/AttributeInput/utils';
import { AttributeInput } from 'packages/common-frontend/components/AttributeInput/AttributeInput';
import { Attribute } from 'packages/common-frontend/components/AttributeInput/types';

export type UpdateParams = {
  attributeId: string;
  type: AttributeTypeGQLType;
  effectiveFromDate: Util.FullDateStr;
  value: AttributeValueInputGQLType;
};

// Editor for attributes that have an effective date associated with them
export const AttributeWithEffectiveDateEditor = ({
  attributes,
  updateAttribute,
}: {
  attributes: Attribute[];
  updateAttribute: (updatedAttribute: UpdateParams) => Promise<void>;
}) => {
  return (
    <SimpleGrid
      columns={{ sm: 2, md: 4, lg: 4, xl: 4 }}
      gap="1.5rem"
      flexGrow={1}
    >
      {attributes.map((attribute) => {
        return (
          <AttributeInput
            key={attribute.attributeValueId || attribute.attributeId}
            attribute={attribute}
            onUpdate={(updatedAttr) => {
              // @makarand-cpv: allow this date to be edited
              const effectiveFromDate = '2020-01-01';
              updateAttribute({
                attributeId: attribute.attributeId,
                type: attribute.type,
                effectiveFromDate,
                value: mapAttributeToGQLValue(updatedAttr),
              });
            }}
          />
        );
      })}
    </SimpleGrid>
  );
};
